<script>
    export let cols = "12";

    let className = $$props.class ? " " + $$props.class : "";
    let style = $$props.style;
</script>

<div class="form-group col-md-{cols}{className}" {style}>
    <slot></slot>
</div>
